import React from 'react';
import { Row, Col, Space, Tooltip, Menu, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {DeleteOutlined, SearchOutlined} from '@ant-design/icons';
import {
    CloseRounded, PaletteRounded, SwapHorizRounded, StopCircleRounded, DeleteForeverRounded
} from "@mui/icons-material";
import {removeEtfFromMatrix} from "../../../store/slices/appState.slice";

import Logo from "../../../components/Graphics/Logo";



const EtfHeader = ({
  name,
  symbol,
  logoUrl,
  onCheck,
  isChecked = false,
  color,
  holdingsCount,
  handleColorUpdate,
}) => {
    const dispatch = useDispatch();

    const onRemove = ()=>{
        dispatch(removeEtfFromMatrix(symbol))
    }

  return (
    <Space direction={'vertical'} style={{width: '100%'}}>
        <Row justify={'space-between'} align={'middle'} className={'pt-2'}>
            <Col>
                <Row align={'middle'}>
                    <Logo src={logoUrl} height={'42px'} width={'42px'} borderRadius={'4px'} background={'#000'} />
                    <Typography.Text ellipsis={{rows: 2, symbol: '..'}} style={{fontSize: '1em', fontWeight: '600', maxWidth: 250}}>{name}</Typography.Text>
                </Row>
            </Col>
            <Col>
                <ButtonGroup size={'small'} orientation={'vertical'} variant={'bordered'}>
                    <Tooltip title={'Compare Holdings to Other ETFs'}>
                        <Button onClick={onCheck}>
                            {isChecked ? <StopCircleRounded style={{color: 'var(--red)'}} /> : <SwapHorizRounded fontSize={'large'} />}
                        </Button>
                    </Tooltip>
                    <Tooltip title={'Remove ETF'}>
                        <Button onClick={onRemove}>
                            <DeleteForeverRounded />
                        </Button>
                    </Tooltip>
                </ButtonGroup>
            </Col>

        </Row>
    </Space>
    // <Row className={'pt-2'} justify="space-between" align="middle" gutter={[2, 16]} wrap={false}>
    //   <Col flex={'1'}>
    //       <Space size={'small'}>
    //           <Dropdown overlay={menu} trigger={['click']}>
    //             <MoreVertRounded />
    //           </Dropdown>
    //           <Typography.Text ellipsis={{rows: 1, symbol:'...'}} style={{fontSize: '1.2em', fontWeight: '600', maxWidth: 250}}>{name}</Typography.Text>
    //       </Space>
    //       {/*  */}
    //     {/*<Row justify="space-between" align="middle" wrap={false}>*/}
    //       {/* ETF Title with Dropdown Menu */}
    //       {/*<TickerChip ticker={{ logo: logoUrl, name, symbol }} titleSuffix={`(${holdingsCount})`} />*/}
    //       {/*<Space>*/}
    //       {/*  /!* Ellipsis Dropdown Menu *!/*/}
    //       {/*  <Dropdown overlay={menu} trigger={['click']}>*/}
    //       {/*    <Button size={'small'}>*/}
    //       {/*      <MoreHorizRounded />*/}
    //       {/*    </Button>*/}
    //       {/*  </Dropdown>*/}
    //       {/*</Space>*/}
    //     {/*</Row>*/}
    //   </Col>
    //     <Col flex={'0 0 100px'}>
    //         <Logo src={logoUrl} height={'64px'} width={'64px'} borderRadius={'8px'} />
    //     </Col>
    // </Row>
  );
};

export default EtfHeader;
